<style scoped>
@import url("../assets/css/question.css");
</style>

<template>
    <div>
      <div class="page-loading" v-show="!show">
            <div class="loading-content">
                <img src="../assets/images/page_loading.gif">
                <p class="title">正在加载...</p>
            </div>
        </div>
      <div class="common-home-content" v-show="show">
          <div class="question-content">
              <p class="question-title">{{index}}、{{title}}</p>
              <div class="question-select clearfix">
              <div class="answer-div fl">
                <button class="choice_select"
                  @click="loadquestion('')"
                >否</button>
              </div>
              <div class="answer-div fr">
                <button class="choice_select"
                  @click="loadquestion('yes')"
                >是</button>
              </div>
            </div>
          </div>
          <button class="again-btn" @click="goBack()">重新自测</button>
      </div>
    </div>
</template>

<script>
import http from '../assets/api/friggApiConfig'
export default {
  data() {
    return {
      traceId: null,
      title: null,
      index: 0,
      show: false
    };
  },
  created() {
    this.traceId = this.$route.params.trace_id;
    this.loadquestion("yes");
    window.appBack = ()=> this.pageback();
  },
  methods: {
    loadquestion(choice){
        var that = this;
        var param = {"trace": that.traceId, "choice": choice}
        http.get("/zhen/goods/panel", {params: param}).then(function(res) {
            var locData = res.data;
            if(locData.question){
                that.index += 1;
                that.traceId = locData.trace;
                that.title = locData.question;
                if(!that.show) that.show = true;
            }else{
              if(that.$route.query.dark){
                  that.$router.push({ path: locData.solution+'?dark='+that.$route.query.dark});
              }else{
                  that.$router.push({ path: locData.solution});
              }
                
            }
        });
    },
    goBack(){
       var that = this;
        if(that.index > 1){
            that.$layer.confirm('“返回”将从头选择症状，以保证症状精准采集。是否继续？', {
                    btn: ['是','否'] 
            }, function(){ 
                that.$layer.closeAll();
                that.pageback();
            }, function(){
                that.$layer.closeAll();
            });
        }else{
            that.pageback();
        }
    },
    pageback(){
      window.history.back();
      return true;
    }  
  }
}
</script>

